// covered-by: frontends/carrie/src/routes/ask-puntt/utils/__tests__/collectInheritedFileTags.test.ts

/**
 * Union of tags from project files, excluding tags already owned by the chat.
 * Display-only inheritance — does not mutate chat.tags.
 */
export function collectInheritedFileTags(
  files: { tags?: string[] | null }[] | null | undefined,
  ownedTags: string[] | null | undefined = [],
): string[] {
  const owned = new Set(
    (ownedTags ?? []).map((t) => t.trim().toLowerCase()).filter(Boolean),
  );
  const seen = new Set<string>();
  const out: string[] = [];
  for (const file of files ?? []) {
    for (const raw of file.tags ?? []) {
      const tag = raw.trim();
      if (!tag) continue;
      const key = tag.toLowerCase();
      if (owned.has(key) || seen.has(key)) continue;
      seen.add(key);
      out.push(tag);
    }
  }
  return out;
}
